import React from 'react'
import Layout from '../../components/layout/Layout/Layout';
import Header from '../../components/layout/Header/Header';
import MediaGrid from '../../components/global/Multimedia/MediaGrid';
import { formatTitle } from '../../utils/helper';
import Head from 'next/head';
 
export default function MultimediaPage() {
  return (
    <Layout>
      <Head>
        <title>{formatTitle('Multimedia')}</title>
      </Head>
      <Header></Header>
      <MediaGrid />
    </Layout>
  );
}
